import { SET_COMPANIES } from '../actions/actionTypes';

const initialState = {
  list: [],
  loading: false,
};

const companiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANIES:
      return { ...state, loading: false, list: action.companies };
    default:
      return state;
  }
};

export default companiesReducer;
